var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('spa-server',[_c('router-view',{attrs:{"is-logged-in":_vm.isLoggedIn}})],1),(!_vm.isLoggedIn)?_c('Login'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }